import { TablePagination, Box } from "@mui/material";
import * as React from "react";

interface TriggerEvaluationsPaginationProps {
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  hasNextPage: boolean;
  totalCount: number;
}

export function TriggerEvaluationsPagination({
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  hasNextPage,
  totalCount,
}: TriggerEvaluationsPaginationProps) {
  const endIndex = (page + 1) * rowsPerPage;

  return (
    <TablePagination
      component={Box}
      count={totalCount}
      page={page}
      rowsPerPage={rowsPerPage}
      slotProps={{
        actions: {
          nextButton: {
            disabled: !hasNextPage && endIndex >= totalCount,
          },
        },
      }}
      labelRowsPerPage="Evaluations per page:"
      rowsPerPageOptions={[10, 25, 50]}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
}
